// extracted by mini-css-extract-plugin
module.exports = {"Container":"SettingsProfiles_Container__Igh2_","Description":"SettingsProfiles_Description__7ZGJU","ProfileList":"SettingsProfiles_ProfileList__9ytL1"};